export default function getSenderNonceKey(tx, ourWalletAddress) {
  if (Array.isArray(tx.from)) {
    // Tx class. we don't define the 'from' address if our wallet was the sender.
    const from = tx.from[0] || ourWalletAddress
    return `${from}:${tx.data.nonce}`
  }

  // ethereum tx json object from magnifier
  const txnonce = parseInt(tx.nonce, 16)
  return `${tx.from}:${txnonce}`
}
